import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=fc11c4c4&scoped=true"
import script from "./richText.vue?vue&type=script&lang=ts"
export * from "./richText.vue?vue&type=script&lang=ts"
import style0 from "./richText.vue?vue&type=style&index=0&id=fc11c4c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc11c4c4",
  null
  
)

export default component.exports